import { render, staticRenderFns } from "./CarriageContract.vue?vue&type=template&id=50461d68&scoped=true&"
import script from "./CarriageContract.vue?vue&type=script&lang=js&"
export * from "./CarriageContract.vue?vue&type=script&lang=js&"
import style0 from "./CarriageContract.vue?vue&type=style&index=0&id=50461d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50461d68",
  null
  
)

export default component.exports